import { interfaces } from "inversify";
import { LoggerFactory, loggerFactoryRTTI, LoggerName } from "~/modules/logger";
import { LocalStorageKeys } from "../LocalStorage/LocalStorageKeys";

export const clearLocalStorage =
    ({ container }: interfaces.Context) =>
    () => {
        const getLogger = container.get<LoggerFactory>(loggerFactoryRTTI);
        const logger = getLogger(LoggerName.Storage);
        logger.debug(`Clearing out Flex SDK local storage cache`);
        Object.values(LocalStorageKeys).forEach((key) => {
            localStorage.removeItem(key);
        });
    };
